// DTOs/schemas do módulo "envio". Este arquivo pertence ao pacote do módulo.
import { z } from "zod";

import { STATUS_MENSAGEM, TIPOS_ENVIO, TIPOS_NUMERO } from "./enums";

/**
 * Erro devolvido pelo canal (Meta ou Evolution) quando um envio falha.
 *  - `codigo`: estável do ZapHub (ex.: "janela_fechada", "numero_invalido", "timeout").
 *  - `codigoExterno`: código numérico da Meta, em texto (ex.: "131047"); null no Evolution.
 *    É o MESMO valor gravado em `Mensagem.erroCodigo` (e que o webhook da Meta grava).
 *  - `mensagem`: PT-BR, pronta para mostrar ao cliente.
 */
export const zErroEnvio = z.object({
  codigo: z.string(),
  codigoExterno: z.string().nullable(),
  mensagem: z.string(),
});
export type ErroEnvio = z.infer<typeof zErroEnvio>;

/** Resultado de um envio individual (corpo do 202 do `/v1` e do envio manual do painel). */
export const zResultadoEnvio = z.object({
  mensagemId: z.string(),
  status: z.enum(STATUS_MENSAGEM),
  tipoEnvio: z.enum(TIPOS_ENVIO),
  /** true = entrou na fila de cadência do número (não oficial) e sai logo em seguida. */
  enfileirada: z.boolean(),
  custoEvitado: z
    .object({ marketingCentavos: z.number().int(), utilityCentavos: z.number().int() })
    .nullable(),
  contatoOptout: z.boolean(),
  janelaAberta: z.boolean(),
  /** Só quando `status = FALHOU`: o erro do canal (na Meta, com o código dela). */
  erro: zErroEnvio.optional(),
});
export type ResultadoEnvioDto = z.infer<typeof zResultadoEnvio>;

/**
 * Indicadores INFORMATIVOS de um número (painel e `GET /v1/numeros/{id}`).
 * Nunca bloqueiam nada; existem para o cliente enxergar o próprio padrão de uso.
 */
export const zIndicadoresNumero = z.object({
  numeroId: z.string(),
  tipo: z.enum(TIPOS_NUMERO),
  geradoEm: z.string(),
  /** Contatos DISTINTOS iniciados (primeiro contato + retomada + contato de lead). */
  iniciosConversa: z.object({ ultimaHora: z.number().int(), hoje: z.number().int() }),
  mensagensEnviadas: z.object({ ultimaHora: z.number().int(), hoje: z.number().int() }),
  desconexoes: z.object({
    ultimas24h: z.number().int(),
    ultimaEm: z.string().nullable(),
  }),
  /** Cadência do número (mensagens/min); null no número oficial. */
  ritmoPorMinuto: z.number().int().nullable(),
  /** Mensagens aguardando a vez na fila de cadência agora. */
  naFila: z.number().int(),
});
export type IndicadoresNumero = z.infer<typeof zIndicadoresNumero>;
